export default __webpack_public_path__ + "static/media/svg-3.8a5bb7b0.svg";